var productSlideshow = document.querySelector(".product-slideshow");
var slides = productSlideshow.querySelectorAll(".slide");
if (slides) {
for (var i = slides.length - 3; i < slides.length; i++) {
  slides[i].style.flex = "1 0 97%";
}

for (var i = slides.length - 4; i <= slides.length - 6; i++) {
  slides[i].style.display = "none";
}
}



document.addEventListener("DOMContentLoaded", function () {
  const reviewsContainer = document.querySelector(".jdgm-rev-widg__reviews");
  const titleElement = document.querySelector(".jdgm-rev-widg__title");

  if (reviewsContainer && reviewsContainer.children.length === 0) {
    const revTitle = document.querySelector("#judgeme_product_reviews");
    revTitle.style.display = "none";
    const newTitleElement = document.createElement("h2");
    newTitleElement.textContent =
      "There are no reviews yet for this product. Check out our thousands of store reviews since 2006 ";
    newTitleElement.className = "no-reviews";
    titleElement.insertAdjacentElement("afterend", newTitleElement);

    const linkElement = document.createElement("a");
    linkElement.href = "https://www.shireeodiz.co.il/pages/%D7%91%D7%99%D7%A7%D7%95%D7%A8%D7%95%D7%AA";
    linkElement.textContent = "here.";
    
    newTitleElement.appendChild(linkElement);
  }
});


// const addToWishListCustom = document.querySelector(".add-to-wishlist-custom");
// const addToWishListCustomSvg = document.querySelector(".add-to-wishlist-custom svg");


// setTimeout(() => {
//   addWishClass()
// }, 1000);


// const addWishClass = () => {
//     const wishText = document.querySelector(".wk-text").textContent;
//      if (wishText === 'In Wishlist') {
//        addToWishListCustomSvg.classList.add('active-add-wish');
//      }
// }

// addToWishListCustom.addEventListener("click", () => {
//   document.querySelector(".wk-icon").click();
//   addToWishListCustomSvg.classList.toggle("active-add-wish");
// });


// custom add to cart logic
// Логика для кнопки с id custom-add-to-cart_step-1
// Функция для добавления товара в корзину
async function addToCart(productId, redirectUrl) {
  const url = "https://www.shireeodiz.co.il/cart/add.js";
  const formData = {
    items: [
      { id: productId, quantity: 1 }
    ]
  };

  try {
    let response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // Указывает на AJAX запрос
      },
      body: JSON.stringify(formData)
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    let data = await response.json();
    console.log('Product added to cart:', data);

    // Перенаправление пользователя
    if (redirectUrl) {
      window.location.href = redirectUrl;
    }
  } catch (error) {
    console.error('Error adding product to cart:', error);
    alert('Ошибка при добавлении товара в корзину. Пожалуйста, попробуйте снова.');
  }
}

// Функция для добавления обработчика события на кнопку
function setupAddToCartButton(buttonId, redirectUrl) {
  const button = document.getElementById(buttonId);
  if (button) {
    button.addEventListener('click', function(event) {
      event.preventDefault(); // Предотвращает стандартное поведение кнопки
      console.log(`Button ${buttonId} clicked`);

      const productId = document.getElementById('product-id').value;
      addToCart(productId, redirectUrl);
    });
  } else {
    console.warn(`Button with id ${buttonId} not found`);
  }
}

// Настройка кнопок
setupAddToCartButton('custom-add-to-cart_step-1', 'https://www.shireeodiz.co.il/pages/natural-diamonds');
setupAddToCartButton('custom-add-to-cart_step-2', 'https://www.shireeodiz.co.il/cart');